/**
 * 字典文件
 */
import {
  majorList,
  industryList,
  metaList,
  statusList,
  functionList,
  categoryList,
} from "@/api/user";
export default {
  // 获取专业分类
  getMajorList(callback) {
    majorList().then((res) => {
      if (res.code === "200") {
        callback ? callback(res.data) : false;
      }
    });
  },

  // 获取行业分类
  getIndustryList(callback) {
    industryList().then((res) => {
      if (res.code === "200") {
        callback ? callback(res.data) : false;
      }
    });
  },

  // 获取元件类型
  getMetaList(callback) {
    metaList().then((res) => {
      if (res.code === "200") {
        callback ? callback(res.data) : false;
      }
    });
  },

  // 获取申请状态
  getStatusList(callback) {
    statusList().then((res) => {
      if (res.code === "200") {
        callback ? callback(res.data) : false;
      }
    });
  },

  // 获取功能分类
  getFunctionList(callback) {
    functionList().then((res) => {
      if (res.code === "200") {
        callback ? callback(res.data) : false;
      }
    });
  },

  // 获取模型分类列表
  getCategoryList(params, callback) {
    categoryList(params).then((res) => {
      if (res.code === "200") {
        callback ? callback(res.data) : false;
      }
    });
  },
};
